export default "__VITE_ASSET__DxvZq_Ps__"